export const DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'out-of-stock'
